import gql from 'graphql-tag';

export const getContacts = gql`
  query getContacts {
    getContacts {
      id
      firstName
      lastName
      nickName
      inactiveAdAccount
      afterHoursPhoneNumber
      speedDial
      version
      adAccountName
      adAccountName
      JobRole {
        id
        name
        version
      }
      Company {
        id
        name
        abbreviation
        version
      }
      city
    }
  }
`;
